const config = {
    REACT_APP_GOOGLE_API_KEY: "AIzaSyCNeyBUPE6ktrmN9doUtzDwwySuQJXG-yc",
    REACT_APP_RAPID_API_KEY: "be7c418c50msha1e43daba45b312p16a697jsn6771e5be6f14",
}

export default config;
